<template>
  <!-- A simple dropdown notification for showing an icon on the left side,
    and showing some text on the right side
    Check created() method for adding action prop
  -->
  <div id="dropdown-notification" v-bind:class="mainClass">
    <div
      class="notification"
      :style="{ backgroundColor, cursor }"
      @click="actionOnClick"
    >
      <div class="notification-icon">
        <div class="icon">
          <img :src="imgPath"  aria-hidden="true"/>
        </div>
      </div>
      <div class="notification-text">
        <div :style=" { color: titleColor } " class="paragraph14 title" :class="description ? '' : 'simple-title'"
          :lang="narratorLang" tabindex="-1" :aria-label="$t(title)"
        >
          {{ $t(title) }}
        </div>
        <div
          :style="{ color }"
          class="paragraph14 description"
          v-if="!isHtmlText && description !== ''"
          :lang="narratorLang"
          tabindex="-1"
          :aria-label="$t(description)"
        >
          {{ $t(description) }}
        </div>
        <div
          :style="{ color }"
          class="paragraph14 description"
          v-if="isHtmlText && description !== ''"
          v-html="description"
          :lang="narratorLang"
          tabindex="-1"
          :aria-label="descriptionAriaLabel"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';

export default {
  name: 'DropdownNotification',
  components: {},
  props: {
    imgPath: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    color: {
      type: String,
      default: '#616161',
    },
    titleColor: {
      type: String,
      default: '#616161',
    },
    mainClass: {
      type: String,
      default: 'normal',
    },
    isBlocked: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Function,
    },
    isHtmlText: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [clickaway],
  data() {
    return {
      actionOnClick: null,
      actionAwayClick: null,
      cursor: 'pointer',
    };
  },
  computed: {
    ...mapGetters({
      narratorLang: 'settings/getNarratorLanguage',
    }),
    descriptionAriaLabel() {
      const parser = new DOMParser();
      const parsedText = parser.parseFromString(this.description, 'text/html');
      return parsedText.documentElement.textContent;
    },
  },
  /**
   * If the action is explicitly null, then we won't do anything,
   * if it is just not set, then we'll close the dropdown notification
   * Otherwise it'll call the given function
   */
  created() {
    if (this.action === null) {
      this.cursor = 'default';
      this.actionOnClick = () => {};
    } else {
      this.actionOnClick = this.action || this.closeNotification;
    }
  },
  methods: {
    closeNotification() {
      // this.$eventBus.$emit("NotificationExpired");
    },
  },
};
</script>

<style lang="scss" scoped>
#dropdown-notification {
  position: fixed;
  z-index: z("modal");
  top: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  margin: auto;
  .notification {
    max-width: 95vw;
    width: 534px;
    position: relative;
    left: -50%;
    margin-top: 1rem;
    // cursor: pointer; // this is set in the created method
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border-radius: 8px;
    box-shadow: 0 3px 6px 0 #00000029;
    // display: inline-block;
    padding: 11.4px 45px 14.3px 22px;
    background-color: var(--white);
  }
  .notification-icon {
    vertical-align: middle;
    padding: 0 15px 0 0;
    .icon {
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .notification-text {
    vertical-align: top;
    .title {
      padding-bottom: 12.3px;
      font-family: Roboto;
      font-size: 17px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: var(--terraGrey);
      &.simple-title {
        padding-bottom: 0;
        height: 58.3px;
        display: flex;
        align-items: center;
      }
    }
    .description {
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: var(--grey);
      font-family: Roboto;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: left;
      color: var(--terraGrey);
    }
  }
}

#dropdown-notification.payment-error {
  pointer-events: none;
  .notification {
    pointer-events: all;
  }
  .icon {
    img {
      width: 40px;
    }
  }
  //   width: 685px;
  //   .notification {
  //     width: initial;
  //     display: block;
  //     padding: 12.5px 26.6px;
  //     .notification-text {
  //       display: inline-block;
  //       width: 80%;
  //       .title {
  //         font-size: 24px;
  //         font-weight: bold;
  //         line-height: 1.21;
  //       }
  //       .description {
  //         font-size: 18px;
  //         line-height: 1.33;
  //       }
  //     }
  //     .notification-icon {
  //       display: inline-block;
  //       width: 19%;
  //       padding: 0;
  //       .icon {
  //         @include v-center-h-center();
  //         img {
  //           width: 48px;
  //           height: auto;
  //         }
  //       }
  //     }
  //   }
}

@media (max-width: $medium-screen) {
  .notification {
    padding: 14px !important;
  }
}
</style>
